import React, {useEffect, useState} from "react";
import {Container} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {RotatableBuilding} from "../../components/RotatableBuilding/RotatableBuilding";
import {FullScreen, useFullScreenHandle} from "react-full-screen";
import Sidebar from "../../components/Sidebar/Sidebar";
import {InfoPopup} from "../../components/RotatableBuilding/InfoPopup";
import {loadCurrentData} from "../../store/actions";

const infoArrayIds = [1, 2, 3, 4, 5, 6, 7, 8];
const infoArrayIds2 = [30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41];


export const DesktopLayout = ({setAppState, loading, setHoveredArea, hoveredArea}) => {
    const {floorImages} = useSelector((state) => state.floor);
    const [currentWidth, setCurrentWidth] = useState(0);
    const [currentHeight, setCurrentHeight] = useState(0);
    const handleFullScreen = useFullScreenHandle();
    const dispatch = useDispatch();
    const {currentPoi} = useSelector(state => state.data);

    const getInfoPosition = (area) => {
        let startInfoPoint;
        let top = 30;
        var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        var vhCalc = (80 * h) / 100;
        if (area.center[0] + 280 - vhCalc - 30 < 0) {
            top = area.center[0] / 2;
            if (parseInt(area.center[1]) < 60) {
                startInfoPoint = area.center[0] / 2;
                // top = 70;
            } else {
                startInfoPoint = area.center[0] + 300;
            }
        } else {
            startInfoPoint = area.center[0] + 280 - vhCalc - 30;
        }
        return {top: `${top}px`, left: `${startInfoPoint}px`};
    };

    return (
        <FullScreen handle={handleFullScreen}>
            <Container fluid className="main-wrapper">
                <div className="d-flex flex-row">
                    {loading && (
                        <div className={"loading-container"}>
                            <div>
                                <div className="loading"/>
                                <div id="loading-text">loading</div>
                            </div>
                            <div className="text-allow">Please allow a few moments for the app to load</div>
                        </div>
                    )}
                    <div id="1" className="building-wrapper p-0">
                        {floorImages.length > 0 && (
                            <RotatableBuilding
                                activeBuilding={1}
                                floorImages={floorImages}
                                setAppState={setAppState}
                                handleFullScreen={handleFullScreen}
                                currentWidth={currentWidth}
                                setCurrentWidth={setCurrentWidth}
                                currentHeight={currentHeight}
                                setCurrentHeight={setCurrentHeight}
                                setHoveredArea={setHoveredArea}
                                hoveredArea={hoveredArea}
                                infoArrayIds={infoArrayIds}
                                infoArrayIds2={infoArrayIds2}
                            />
                        )}

                        <Sidebar
                            setAppState={setAppState}
                            hoveredArea={hoveredArea}
                            isInfoDataExist={(infoArrayIds.includes(parseInt(hoveredArea?.name.id)) || infoArrayIds2.includes(parseInt(hoveredArea?.name.id)))}
                            setHoveredArea={setHoveredArea}
                        />
                    </div>
                    {hoveredArea && ((infoArrayIds.includes(parseInt(hoveredArea.name.id)) || infoArrayIds2.includes(parseInt(hoveredArea.name.id))) &&
                        <>
                            {/*<div id={'infoPopup-wrapper'} onClick={() => {*/}
                            {/*    setHoveredArea(null);*/}
                            {/*    dispatch(loadCurrentData());*/}
                            {/*}}*/}
                            {/*     onTouchStart={() => {*/}
                            {/*         setHoveredArea(null);*/}
                            {/*         dispatch(loadCurrentData());*/}
                            {/*     }}/>*/}
                            <div className="infoPopup" style={{...getInfoPosition(hoveredArea)}}>
                                {hoveredArea && hoveredArea.name &&
                                    <InfoPopup hoveredArea={hoveredArea}/>
                                }
                            </div>

                        </>
                    )
                    }
                </div>
            </Container>
        </FullScreen>
    );
};
